var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C1229",
    d: "M18.558 6.928l-2.142 2.141-3.444-3.444 2.142-2.141c.172-.173.406-.27.65-.27.243 0 .477.097.649.27l2.145 2.145c.173.172.27.406.27.65 0 .243-.097.477-.27.649zM3.214 15.383l9.244-9.243 3.444 3.444-9.244 9.243H3.215v-3.444zm12.51-11.209l-1.413 1.414 2.146 2.144 1.412-1.413-2.144-2.145zm-1.16 5.451L12.42 7.48l-8.286 8.285v2.145h2.145l8.285-8.285z",
    transform: "translate(.575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22.042V22.042H0z",
    transform: "translate(.575)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.3253d17603fd844efb85c89a9c1213f9.svg";
export { ForwardRef as ReactComponent };